import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserManagementService } from 'src/app/Services/UserManagement/user-management.service';


@Component({
  selector: 'app-login-model',
  templateUrl: './login-model.component.html',
  styleUrls: ['./login-model.component.css']
})
export class LoginModelComponent implements OnInit {
  registerForm: FormGroup;
  submitted = false;
  constructor(private _router: Router,
    private userService: UserManagementService
    , private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
    , private toastr: ToastrService
    , private formBuilder: FormBuilder) { }
  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      username: [sessionStorage.getItem("username")],
      password: ['', [Validators.required, Validators.minLength(2)]]
    });

  }
  get f() { return this.registerForm.controls; }
  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.registerForm.invalid) {
      return;
    }
    if (this.submitted) {
      const sendPassword = this.registerForm.value.password
      this.userService.getLoginDetailsByUserId(sendPassword).subscribe((data: any) => {
        if (data && data != undefined) {
          if (data.wrongAttempts != 0) {
            if (data.includes('Invalid') || data.includes('0 more')) {
              this.toastr.error(data);

            } else if (data.includes('Access Locked')) {
              this.toastr.error("Your Password access locked .Please contact Administrator")

            }
            else if (data == 'success') {
              this.dialogRef.close('success');

            }
            // else
            //   this.toastr.error(" Password not Available.")
          }


        } else {
          this.toastr.error(" Password Not Available.")
        }
      });
      // this.showModal = false;
    }

  }
  btnlogout_click() {

    localStorage.clear();
    sessionStorage.clear();
    this._router.navigate(['/login']);
    this.dialogRef.close('logout');
    window.location.reload()
  }


}
